import validator from "validator";
import message from "../../../messages/auth";
import mobileValidator from "../../mobile";

const validationCredential = (credential) => {
  if (validator.isNumeric(credential)) {
    const mobile = credential;
    return validateMobile(mobile);
  } else {
    const email = credential;
    return validateEmail(email);
  }
};

const validateEmail = (email) => {
  if (validator.isEmpty(email)) {
    return message.EMAIL_DOSE_NOT_EXIST;
  }

  if (!email.trim().length) {
    return message.EMAIL_DOSE_NOT_EXIST;
  }

  if (!validator.isEmail(email)) {
    return message.EMAIL_INVALID;
  }

  return true;
};

const validateMobile = (mobile) => {
  if (validator.isEmpty(mobile)) {
    return message.USER_MOBILE_DOSE_NOT_EXIST;
  }

  if (!mobile.trim().length) {
    return message.USER_MOBILE_DOSE_NOT_EXIST;
  }

  if (!mobileValidator.isNumericMobile(mobile)) {
    return message.USER_MOBILE_WRONG;
  }

  if (!mobileValidator.validMobileNumber(mobile)) {
    return message.USER_MOBILE_WRONG;
  }

  return true;
};

const validatePassword = (password) => {
  if (validator.isEmpty(password)) {
    return message.PASSWORD_DOSE_NOT_EXIST;
  }

  if (!password.trim().length) {
    return message.PASSWORD_DOSE_NOT_EXIST;
  }

  const regexHasNumber = /\d/g;
  if (regexHasNumber.test(password)) {
    var regexHasLetter = /[a-zA-Z]/g;
    if (regexHasLetter.test(password)) {
      return true;
    } else {
      return message.PASSWORD_MUST_HAVE_ONE_LETTER;
    }
  } else {
    return message.PASSWORD_MUST_HAVE_ONE_NUMBER;
  }
};

const validationLogin = (info) => {
  const resValidateCredential = validationCredential(info.credential);
  if (resValidateCredential != true) {
    return resValidateCredential;
  }
  const resValidatePassword = validatePassword(info.password);
  if (resValidatePassword != true) {
    return resValidatePassword;
  }

  return true;
};

export default validationLogin;
